"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APButton = _interopRequireDefault(require("../../../../common/APButton"));
var _cssClassesHelper = require("../../../../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var resetPasswordFormClasses = (0, _cssClassesHelper.getBEMClasses)('reset-password-form');
var ResetPasswordConfirmComponent = function ResetPasswordConfirmComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("auth"),
    t = _useTranslation.t;
  var submitting = props.submitting,
    handleSubmit = props.handleSubmit;
  return /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: resetPasswordFormClasses('text-info')
  }, t("Check your email with instructions on changing your password")), /*#__PURE__*/_react["default"].createElement("div", {
    className: resetPasswordFormClasses('button-container')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    customClass: resetPasswordFormClasses()
  }, submitting ? t("Processing...") : t("Send Email"))));
};
ResetPasswordConfirmComponent.propTypes = {
  submitting: _propTypes["default"].bool
};
var _default = exports["default"] = ResetPasswordConfirmComponent;